import { Link } from "@tanstack/react-router";
import { useSiteData } from "@/lib/use-site-data";

export function TarifasSection({ heading = "Tarifas" }: { heading?: string }) {
  const { config } = useSiteData();
  return (
    <section className="mx-auto max-w-6xl px-4 py-20 md:px-6">
      <h2 className="font-serif text-3xl text-foreground md:text-4xl">{heading}</h2>

      <div className="mt-8 grid gap-10 lg:grid-cols-2">
        <div>
          <p className="text-xs uppercase tracking-[0.28em] text-accent">Casa completa · hasta 14 personas</p>
          <p className="mt-2 text-sm text-muted-foreground">Toda la casa solo para vosotros: habitaciones, cocina y salón con chimenea.</p>
          <div className="mt-5 grid grid-cols-3 gap-3 text-center">
            {[["Baja demanda", "690 €"], ["Habitual", "790 €"], ["Alta demanda", "890 €"]].map(([t, p]) => (
              <div key={t} className="rounded-sm border border-border bg-card p-4">
                <p className="text-xs text-muted-foreground">{t}</p>
                <p className="mt-1 font-serif text-2xl text-foreground">{p}</p>
                <p className="text-xs text-muted-foreground">fin de semana · 2 noches</p>
              </div>
            ))}
          </div>
          <ul className="mt-5 space-y-3 text-sm text-foreground/85">
            {[
              ["Entre semana, sin festivos", "290 €/noche · mín. 2 noches"],
              ["Puentes y Semana Santa", "450 €/noche · mín. 3 noches"],
              ["Nochevieja (30 dic – 2 ene)", "1.650 € / 3 noches"],
              ["Semana completa en temporada baja", "1.650 € / 7 noches"],
            ].map(([a, b]) => (
              <li key={a} className="flex justify-between gap-4 border-b border-border pb-3"><span>{a}</span><span className="text-right font-medium">{b}</span></li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.28em] text-accent">Por habitaciones · baño privado</p>
          <p className="mt-2 text-sm text-muted-foreground">La cocina y el salón se comparten con los demás huéspedes.</p>
          <table className="mt-5 w-full text-sm">
            <thead className="text-left text-xs text-muted-foreground">
              <tr className="border-b border-border"><th className="pb-2 font-normal">Temporada</th><th className="pb-2 text-right font-normal">Doble</th><th className="pb-2 text-right font-normal">Individual</th></tr>
            </thead>
            <tbody className="text-foreground/85">
              {[
                ["Entre semana, sin festivos", 70, 55],
                ["Fin de semana baja demanda", 75, 60],
                ["Fin de semana habitual", 85, 65],
                ["Temporada alta", 95, 75],
                ["Puentes y Semana Santa", 105, 85],
              ].map(([t, d, i]) => (
                <tr key={t} className="border-b border-border"><td className="py-3">{t}</td><td className="py-3 text-right font-medium">{d} €</td><td className="py-3 text-right font-medium">{i} €</td></tr>
              ))}
            </tbody>
          </table>
          <p className="mt-3 text-xs text-muted-foreground">Precios por noche. Persona adicional: 20 €/noche, solo en habitaciones habilitadas.</p>
        </div>
      </div>

      <div className="mt-12 rounded-sm bg-secondary/40 p-6 text-sm text-foreground/85">
        <h3 className="font-serif text-xl text-foreground">Calendario de temporadas</h3>
        <ul className="mt-4 space-y-2">
          <li><strong>Baja demanda:</strong> del 8 de enero al 28 de febrero y del 1 de noviembre al 20 de diciembre, excepto puentes.</li>
          <li><strong>Habitual:</strong> del 1 de marzo al 30 de junio y septiembre, excepto Semana Santa, puentes y festivos.</li>
          <li><strong>Alta demanda:</strong> julio y agosto, los fines de semana de octubre y del 21 de diciembre al 7 de enero, excepto Nochevieja.</li>
          <li><strong>Fechas especiales:</strong> Semana Santa y puentes nacionales, de Castilla-La Mancha y de Madrid (mínimo 3 noches).</li>
          <li><strong>Nochevieja:</strong> paquete del 30 de diciembre al 2 de enero, con prioridad a la casa completa.</li>
        </ul>
        <p className="mt-4 text-xs text-muted-foreground">Estancia mínima: dos noches en fin de semana y tres en puentes y Semana Santa. {config.tarifas_nota}</p>
        <Link to="/reserva" className="mt-6 inline-block rounded-full bg-primary px-6 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90">Comprobar disponibilidad y precio</Link>
      </div>
    </section>
  );
}
